import React, { useEffect, useState } from "react";
import BillIndex from "./BillIndex";
import CommittedExpendature from "./CommittedExpendatureIndex";
import PendingProposal from "./PendingProposalIndex.js";
import OrderIndex from "./OrderIndex";
import can from "../../../Middleware/Permission";

const ProposalIndex = ({ pageIndex }) => {
  if (can("Accept Account Proposal")) {
    pageIndex = 1;
  } else if (can("Can Audit")) {
    pageIndex = 4;
  } else if (can("Add Bills")) {
    pageIndex = 3;
  } else {
    pageIndex = 1;
  }
  const [page, setPage] = useState(pageIndex ?? 1);
  useEffect(() => {
    console.log(pageIndex);
  }, [pageIndex]);
  return (
    <>
      <div className='py-2'>
        <div className='bg-white shadow-md'>
          <nav className='flex justify-between'>
            <div className='flex'>
              {(can("Accept Account Proposal") ||
                can("Account Proposal Entry") ||
                can("View Proposals")) && (
                <>
                  <a
                    href='#'
                    onClick={() => {
                      setPage(1);
                    }}
                    className={`py-4 px-6 text-lg font-semibold text-white
                 hover:bg-green-500 hover:text-white focus:bg-green-500 focus:text-white
                 
                 ${page == 1 ? "bg-green-500 text-white" : "text-gray-800"}
                `}
                  >
                    Submitted Proposals
                  </a>
                  <a
                    href='#'
                    onClick={() => {
                      setPage(2);
                    }}
                    className={`py-4 px-6 text-lg font-semibold text-white hover:bg-yellow-500 hover:text-white focus:bg-yellow-500 focus:text-white
                ${page == 2 ? "bg-yellow-500 text-white" : "text-gray-800"}
                `}
                  >
                    Committed Expenditure
                  </a>
                </>
              )}
              {can("Accept Account Proposal") ||
              can("Account Proposal Entry") ||
              can("View Proposals") ||
              can("Add Bills") ||
              can("Can Audit") ? (
                <a
                  href='#'
                  onClick={() => {
                    setPage(3);
                  }}
                  className={`py-4 px-6 text-lg font-semibold text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white
                ${page == 3 ? "bg-blue-500 text-white" : "text-gray-800"}
                `}
                >
                  Generated Orders
                </a>
              ) : null}
              {can("Accept Account Proposal") ||
              can("Can Audit") ||
              can("Add Bills") ? (
                <a
                  href='#'
                  onClick={() => {
                    setPage(4);
                  }}
                  className={`py-4 px-6 text-lg font-semibold text-white hover:bg-purple-500 hover:text-white focus:bg-purple-500 focus:text-white
                ${page == 4 ? "bg-purple-500 text-white" : "text-gray-800"}
                `}
                >
                  Bills
                </a>
              ) : null}
            </div>
          </nav>
        </div>

        {page == 1 && (
          <PendingProposal
            tabChange={(pageNo) => {
              setPage(pageNo);
            }}
          />
        )}
        {page == 2 && (
          <CommittedExpendature
            tabChange={(pageNo) => {
              setPage(pageNo);
            }}
          />
        )}
        {page == 3 && (
          <OrderIndex
            tabChange={(pageNo) => {
              setPage(pageNo);
            }}
          />
        )}
        {page == 4 && (
          <BillIndex
            tabChange={(pageNo) => {
              setPage(pageNo);
            }}
          />
        )}
      </div>
    </>
  );
};

export default ProposalIndex;
